export const ArmorMasterEvents = {
  // GetToken: 'Boilerplate.GetToken',
  // TokenReturned: 'Boilerplate.TokenReturned',
}
